<template>
  <div 
    class="tms-button-wrapper"
    :style="
      'padding-top:' + config.property_data.margin_top + 'px;' +
      'padding-bottom:' + config.property_data.margin_bottom + 'px;' +
      'padding-left:' + config.property_data.margin_left + 'px;' +
      'padding-right:' + config.property_data.margin_right + 'px;' +
      'text-align:' + config.property_data.alignment + ';'
    "
  >
    <el-button
      v-if="!config.property_data.link"
      :type="config.property_data.button_type"
      :size="config.property_data.size"
      :plain="config.property_data.plain"
      :loading="config.property_data.loading"
      :disabled="config.property_data.disabled"
      :round="config.property_data.shape === 'round'"
      :circle="config.property_data.shape === 'circle'"
    >
      {{ config.property_data.text }}
    </el-button>
    <el-button
      v-else
      :type="config.property_data.button_type"
      :size="config.property_data.size"
      :plain="config.property_data.plain"
      :loading="config.property_data.loading"
      :disabled="config.property_data.disabled"
      :round="config.property_data.shape === 'round'"
      :circle="config.property_data.shape === 'circle'"
      @click.stop="handleLinkClick"
    >
      {{ config.property_data.text }}
    </el-button>
  </div>
</template>

<script>
export default {
  name: "tms-button",
  props: ["config"],
  data() {
    return {}
  },
  computed: {
    conf() {
      return this.config.property_data;
    }
  },
  components: {},
  methods: {
    handleLinkClick() {
      const link = this.config.property_data.link;
      const openType = this.config.property_data.open_type;
      
      // 确保链接包含协议前缀
      let fullLink = link;
      if (link && !link.match(/^http[s]?:\/\//)) {
        fullLink = 'http://' + link;
      }
      
      // 根据打开方式执行跳转
      if (openType === '_blank') {
        window.open(fullLink, '_blank');
      } else {
        window.location.href = fullLink;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>